import "@fontsource/inter"
import LogoCook from '../assets/LogoCook.png'
import styled from "styled-components"

import { useNavigate, useLocation } from "react-router-dom"

const Navigation = () => {

    const navigate = useNavigate()
    const location = useLocation()

    const scrollToQuote = () => {
        if (location.pathname === "/") {
            // already home — just scroll
            const quoteSection = document.getElementById('request-quote')
            if (quoteSection) {
                quoteSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
            }
        } else {
            // navigate home, then let Home's useEffect handle the scroll
            navigate('/', { state: { scrollTo: 'request-quote' } })
        }
    }

    return(
        <NavigationMainContainer>
            <PhotoHeader src={LogoCook} onClick={() => navigate('/')}/>
            <BannerText>Web Developer for Hire</BannerText>
            <QuoteButton onClick={scrollToQuote}>Request a Quote</QuoteButton>
        </NavigationMainContainer>
    )   
}

const NavigationMainContainer = styled.div`
    display: grid;
    grid-template-columns: minmax(0, auto) minmax(0, 1fr) minmax(0, auto);
    align-items: center;
    gap: 10px;
    background-color: #0D47A1;
    padding: 10px;

    @media (max-width: 700px) {
        grid-template-columns: minmax(0, auto) minmax(0, 1fr);
        grid-template-rows: auto auto;
        row-gap: 10px;
    }
`

const BannerText = styled.p`
    margin: 0;
    justify-self: center;
    text-align: center;
    min-width: 0;
    font-size: clamp(1rem, 2.6vw, 2.25rem);
    color: #E3F2FD;

    @media (max-width: 700px) {
        grid-column: 1 / -1;
        justify-self: center;
        white-space: normal;
        order: 3;
    }
`

const PhotoHeader = styled.img`
    width: clamp(48px, 8vw, 80px);
    height: clamp(48px, 8vw, 80px);
    object-fit: cover;
    justify-self: start;
    margin-left: 5%;
    cursor: pointer;
    flex-shrink: 0;

    @media (max-width: 700px) {
        margin-left: 12px;
    }
`

const QuoteButton = styled.button`
    justify-self: end;
    margin-right: 5%;
    padding: clamp(8px, 1.2vw, 10px) clamp(12px, 2vw, 20px);
    background-color: #2196F3;
    color: #E3F2FD;
    border: none;
    border-radius: 4px;
    font-family: inherit;
    font-size: clamp(13px, 1.4vw, 16px);
    white-space: nowrap;
    cursor: pointer;
    transition: background-color 0.2s ease;
    flex-shrink: 0;

    &:hover{
        background-color: #1976D2;
    }

    @media (max-width: 700px) {
        margin-right: 12px;
    }
`

export default Navigation